import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StudyDataState } from './reducers';

import * as fromComparables from './reducers/comparables.reducer';

export const selectStudyDataState = createFeatureSelector<StudyDataState>('selectedStudy');

const selectComparables = createSelector(selectStudyDataState, (data) => data.comparables);

const selectComparablesDetails = createSelector(selectComparables, (comparables) => comparables.details);

export const selectAllComparables = createSelector(selectComparablesDetails, fromComparables.selectEntities);
